// @flow

import React from "react";
import type { ComponentType } from "react";
import { Redirect } from "react-router";

import type { UserProfile } from "../types/user_profile";
import Routes from "../lib/routes";

type Props = {
  user: ?UserProfile,
  path: string
};

const LoginRequired = (
  WrappedComponent: ComponentType<Object>
): ComponentType<Object> => {
  return (props: Props) => {
    if (props.user) {
      return <WrappedComponent {...props} />;
    } else {
      return (
        <Redirect
          push
          to={{
            pathname: Routes.login(),
            state: { next: props.path }
          }}
        />
      );
    }
  };
};

export default LoginRequired;



// WEBPACK FOOTER //
// ./src/lib/LoginRequired.js